module.exports = __webpack_public_path__ + "img/logo.c813b9b7.png";